var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_438_1006)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.356,
    r: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 16H16.8307C15.8438 16 15.0662 15.1588 15.1437 14.1749L15.3495 11.5595C15.4188 10.6791 16.1535 10 17.0366 10H24V16Z",
    fill: "#FFB6BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 17.4999C14 15.5657 12.8865 13.9999 11.5109 13.9999C10.1354 13.9999 9 15.5657 9 17.4999C9 19.4341 10.1135 20.9999 11.4891 20.9999C12.8646 20.9999 14 19.4341 14 17.4999Z",
    fill: "#FFB6BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.97495 8.18962H13.4458V6.63469C13.4458 5.42326 14.3632 4.16708 15.8172 4.16708H22.444C23.898 4.16708 24.8153 5.42326 24.8153 6.63469V26.8018C24.8153 28.0133 23.898 29.2695 22.444 29.2695H15.7942C15.7045 29.2695 15.6166 29.2616 15.5312 29.2465H14.8767C14.725 29.2465 14.5785 29.2239 14.4404 29.182C14.2773 29.2226 14.1045 29.2445 13.9232 29.2445H8.83272C7.51635 29.2445 6.69067 28.0901 6.69067 27.0315V24.805C6.61367 24.6247 6.56658 24.4286 6.55531 24.2236L5.29738 10.0514C5.29346 10.0073 5.2915 9.96307 5.2915 9.91879C5.2915 9.60191 5.37528 9.20411 5.64712 8.84735C5.94495 8.45648 6.42151 8.18962 6.97495 8.18962ZM13.3118 22.8069H9.44135L8.4102 11.1896H14.3242L13.3118 22.8069ZM9.69067 25.8312H13.0653V26.2445H9.69067V25.8312ZM16.0653 24.7934C16.1379 24.6243 16.1878 24.4334 16.1997 24.2243L16.2125 24.0774H21.815V26.2465H16.0653V24.7934ZM17.4317 10.0868C17.5246 9.3279 17.1025 8.62841 16.4458 8.33508V7.16708H21.8153V21.0774H16.4739L17.4317 10.0868Z",
    fill: "#3D0E6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_438_1006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.ead46dcb56cbb4852f91ace916276912.svg";
export { ForwardRef as ReactComponent };